// extracted by extract-css-chunks-webpack-plugin
module.exports = {"rightContent":"rightContent-2NFF9VVR"};